
import Vue from 'vue'

export default Vue.extend({
  name: 'OutlinedCube',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
